import cn from "classnames";
import * as uuid from "uuid";

import Loading from "@ui-kit/Loading/Loading";
import Tooltip from "@ui-kit/Tooltip/Tooltip";

import s from "./TicketsInput.module.scss";

const TicketsInput = ({
  required = false,
  isError,
  errors,
  label,
  className,
  withoutMessage = false,
  errorWithoutMessage = false,
  inputRef,
  tooltipText,
  loading = false,
  onClick,
  readOnlyStyle = false,
  ...props
}) => {
  const id = uuid.v4();
  const classes = cn(
    s.ticketsInput,
    (errors || errorWithoutMessage) && s.error,
    withoutMessage && s.withoutMessage,
    props.disabled && s.disabled,
    readOnlyStyle && s.readOnlyStyle,
    className,
  );

  const handleClick = (e) => {
    if (props.disabled) {
      return;
    }
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <div className={classes} onClick={handleClick}>
      {label && (
        <label htmlFor={id}>
          {`${label}${required ? " *" : ""}`}
          {tooltipText && (
            <Tooltip className={s.tooltip}>{tooltipText}</Tooltip>
          )}
        </label>
      )}
      <input id={id} type="text" {...props} ref={inputRef} />
      {loading && <Loading size={8} className={s.loading} />}
      {errors && <div className={s.message}>{errors}</div>}
    </div>
  );
};

export default TicketsInput;
